export default __webpack_public_path__ + "static/media/iconCopy.9552b752.svg";